import * as types from "./actionTypes";

const initialState = {
  data: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ADDRESSES_FETCH_SUCCESS:
      return {
        ...state,
        data: action.payload.addresses,
        loading: true,
      };

    default:
      return state;
  }
};
